import { EntityService } from './EntityService';

export class AgreementConfigService extends EntityService {
    static entity: string = 'iam-agreement-config';

    // Lifecycle Management
    static expire(agreementPartyTypeConfId: string): Promise<any> {
        return this.axios.put(`${this.entity}/${agreementPartyTypeConfId}/expire`).then(res => res.data);
    }

    static activate(agreementPartyTypeConfId: string): Promise<any> {
        return this.axios.put(`${this.entity}/${agreementPartyTypeConfId}/activate`).then(res => res.data);
    }

    static restore(agreementPartyTypeConfId: string): Promise<any> {
        return this.axios.put(`${this.entity}/${agreementPartyTypeConfId}/restore`).then(res => res.data);
    }

    // Organization Roles
    static getRoles(lazyLoadEvent?: string): Promise<any> {
        return this.axios.get(`${this.entity}/roles?lazyLoadEvent=${lazyLoadEvent}`).then(res => res.data);
    }

    static createRole(data: { roleTypeId?: string, description: string }): Promise<any> {
        return this.axios.post(`${this.entity}/roles/create`, data).then(res => res.data);
    }

    static updateRole(roleTypeId: string, data: { description: string }): Promise<any> {
        return this.axios.put(`${this.entity}/roles/${roleTypeId}/update`, data).then(res => res.data);
    }
    static findRoles(term: string = ''): Promise<any> {
        return this.axios.get(`${this.entity}/roles/find?term=${term}`).then(res => res.data);
    }
}
